var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCaretIcon = function SvgCaretIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -4 11 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.43 7.999L.827 13.436a1.476 1.476 0 000 2.125 1.58 1.58 0 002.188 0l7.053-6.851a.982.982 0 000-1.422L3.016.438A1.596 1.596 0 001.922 0 1.57 1.57 0 00.828.437a1.476 1.476 0 000 2.125L6.43 8z"
  })));
};
export default SvgCaretIcon;